import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@mui/material";
import FilterAltOutlined from "@mui/icons-material/FilterAltOutlined";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import PushPinOutlined from "@mui/icons-material/PushPinOutlined";
import { MButton } from "../../M_Components";
import { useTranslation } from "react-i18next";

import "./TableHeader.css";

export default function TableHeader({
  // TableHeader component for table actions
  filterCount = 0,
  onRefresh,
  onExport,
  onImport,
  onOpenViews,
  onOpenFilters,
  onOpenColumns,
}) {
  const { t } = useTranslation();

  return (
    <div className="table-header-root">
      <div className="table-header-left">
        <MButton // Button for refreshing the table
          label={t("Refresh")}
          icon={
            <i
              className="pi pi-refresh"
              style={{ fontSize: "1.2rem", fontWeight: "bold" }}
            />
          }
          onClick={() => typeof onRefresh === "function" && onRefresh()}
          clickFunction={() => typeof onRefresh === "function" && onRefresh()} // Refresh function passed as prop
        />

        {onExport && (
          <MButton
            label={t("Export Excel")}
            icon={
              <i
                className="pi pi-file-excel iconTable"
                style={{ color: "var(--color-green)" }}
              />
            }
            onClick={onExport}
          />
        )}

        {onImport && (
          <MButton
            label={t("Import Excel")}
            icon={
              <i
                className="pi pi-upload iconTable"
                style={{ color: "var(--color-green)" }}
              />
            }
            onClick={onImport}
          />
        )}
      </div>

      <div className="table-header-right">
        <MButton // Button for opening views
          label={t("Views")}
          icon={<PushPinOutlined style={{ transform: "rotate(45deg)" }} />}
          onClick={onOpenViews}
          clickFunction={onOpenViews} // Function to open views passed as prop
        />
        <MButton // Button for opening filters
          id={"advFilter"}
          label={t("Filters")}
          icon={
            <Badge badgeContent={filterCount}>
              <FilterAltOutlined />
            </Badge>
          }
          onClick={onOpenFilters}
          clickFunction={onOpenFilters} // Function to open filters passed as prop
        />
        <MButton // Button for editing columns
          label={t("editColumns")}
          icon={<VisibilityOutlined />}
          onClick={onOpenColumns}
          clickFunction={onOpenColumns} // Function to open columns passed as prop
        />
      </div>
    </div>
  );
}

TableHeader.propTypes = {
  filterCount: PropTypes.number,
  onRefresh: PropTypes.func,
  onExport: PropTypes.func,
  onImport: PropTypes.func,
  onOpenViews: PropTypes.func,
  onOpenFilters: PropTypes.func,
  onOpenColumns: PropTypes.func,
};
